import { useLayoutEffect, useState } from 'react';

import { AvailableSearchParams, getSearchParam } from '@/lib/params';

import { useMessageListener, ReceivedMessageAction } from './useMessageListener';

export type PossibleTheme = 'dark' | 'light';

export type ThemeMessage = {
  action: ReceivedMessageAction.SET_THEME;
  data: {
    theme: PossibleTheme;
  };
};

export const applyThemeChange = (desiredTheme: PossibleTheme) => {
  if (!document?.body) {
    return;
  }

  document.body.setAttribute('data-eduzz-theme', desiredTheme);
};

export const useTheme = () => {
  const [theme, setTheme] = useState<PossibleTheme>(
    getSearchParam(AvailableSearchParams.THEME, 'light') as PossibleTheme
  );

  useMessageListener<ThemeMessage>({
    [ReceivedMessageAction.SET_THEME]: message => {
      const newTheme = message?.data?.theme;

      if (!newTheme) {
        return;
      }

      setTheme(newTheme);
    }
  });

  useLayoutEffect(() => {
    applyThemeChange(theme);
  }, [theme]);

  return [theme, setTheme] as const;
};
